<template lang="pug">
div
  HowThisWorks
  v-card.mt-2.px-4
    v-card-title What do you drive?
    v-row(dense, justify="center", align="start")
      v-col(cols=12)
        v-card-subtitle(style="text-align: center") Which type of car would you like to compare to an electric car?
    v-row(dense, justify="center", align="start")
      v-col(cols=6)
        v-select(v-model="bubble.fuelType", :items="fuelOptions", attach)
    v-row(dense, justify="center", align="start")
      v-card.pa-2.ma-2(v-on:click="selectCarType(0)", :flat="carType != 0")
        v-img(
          src="https://powersell.appstack.me/icons/hybrid.svg",
          width="80",
          height="80",
          style="transform: scaleX(-1)",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label Hybrid
      v-card.pa-2.ma-2(v-on:click="selectCarType(1)", :flat="carType != 1")
        v-img(
          src="https://powersell.appstack.me/icons/compact.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label Efficient
      v-card.pa-2.ma-2(v-on:click="selectCarType(2)", :flat="carType != 2")
        v-img(
          src="https://powersell.appstack.me/icons/standard_car.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label Standard
      v-card.pa-2.ma-2(v-on:click="selectCarType(3)", :flat="carType != 3")
        v-img(
          src="https://powersell.appstack.me/icons/gas_guzzler.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label Gas Guzzler

  v-card.mt-2
    v-card-title Where do you park your vehicle?
    v-card-text Do you have off-street parking at home or work, with access to a bog-standard electrical socket? Or would you rely on public charging?
    v-row(dense, justify="center", align="start")
      v-card.pa-2.ma-2(
        v-on:click="selectChargeAtPark(true)",
        :flat="!bubble.chargeAtPark"
      )
        v-img(
          src="https://powersell.appstack.me/icons/private_charging.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label Yes, Private
      v-card.pa-2.ma-2(
        v-on:click="selectChargeAtPark(false)",
        :flat="bubble.chargeAtPark"
      )
        v-img(
          src="https://powersell.appstack.me/icons/public_charging.svg",
          width="80",
          height="80",
          v-bind:class="{ white: $vuetify.theme.dark }"
        )
        span.button-label No, Public
  v-row
    v-col.right
      v-btn.ma-4(color="primary", @click="$emit('next')") Next
</template>

<script>
import HowThisWorks from "./HowThisWorks";
export default {
  components: { HowThisWorks },
  props: ["sortedCars", "bubble", "settings"],
  data() {
    return {
      fuelOptions: ["Petrol", "Diesel"],
      carType: 2,
    };
  },
  methods: {
    selectCarType(index) {
      this.carType = index;
      this.settings.petrolConsumption = this.$dealer.default_settings.default_settings.carTypes[
        index
      ].petrolConsumption;
      this.settings.dieselConsumption = this.$dealer.default_settings.default_settings.carTypes[
        index
      ].dieselConsumption;
    },
    selectChargeAtPark(val) {
      this.bubble.chargeAtPark = val;
    },
  },
  mounted() {
    this.selectCarType(this.carType);
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
}
.small {
  font-size: 0.9em;
}
.km-indicator {
  font-weight: bold;
}
.petrol-indicator,
.diesel-indicator {
  font-style: italic;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

.v-select__selection {
  width: 100%;
  justify-content: center;
}

.button-label {
  font-size: 0.8em;
  display: block;
  text-align: center;
  margin-top: -10px;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>

